export default __webpack_public_path__ + "static/media/employee.1da42e76.pdf";